export function getAdMediaList(ad) {
  if (!ad) return [];
  const media = Array.isArray(ad.Media) ? ad.Media : [];
  return media.filter((item) => {
    if (!item?.Url) return false;
    const type = (item.Type || item.type || "image").toLowerCase();
    return type !== "video" && type !== "youtube";
  });
}

export function getAdDisplayImage(ad) {
  const media = getAdMediaList(ad);
  if (media.length > 0) return media[0].Url;
  return ad?.Photo || "";
}

export function getAdId(ad) {
  return ad?.Id || ad?.id || "";
}

export function isImageMedia(item) {
  if (!item?.Url) return false;
  const type = (item.Type || item.type || "image").toLowerCase();
  return type !== "video" && type !== "youtube";
}
